import { Errors } from "../../ts/Errors";

export const SET_ERRORS = (errors: Errors) => {
  return {
    type: "SET_ERRORS",
    payload: errors,
  };
};
